// ============================================================
// Cost-per-tonne calculation (mock).
// Formula:  cost_per_tonne_Kč = milling_kWh_per_t × OTE_price_Kč/MWh / 1000 + fixed_Kč
// Default constants align with `mockData.planningData.energyTariffs`.
// ============================================================

import { planningData } from '@/data/mockData';

export const MILLING_KWH_PER_TONNE = 35; // GCC literature, calibrated to Pomezí
export const FIXED_COST_PER_TONNE_KC = 50; // labour + logistics fixed (mock)

/**
 * Returns the active OTE tariff entry for a given local time-of-day string ("HH:MM").
 * Defaults to current local hour if no arg.
 */
export function currentTariff(now = new Date()) {
  const hhmm = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  // Tariffs are defined as "HH:MM–HH:MM"
  for (const t of planningData.energyTariffs) {
    const [from, to] = t.period.split('–');
    if (hhmm >= from && hhmm < to) return t;
  }
  return planningData.energyTariffs[0];
}

/**
 * Returns Kč/tonne for a given tariff object (or current).
 */
export function costPerTonne(tariff = currentTariff()) {
  const energyCost = (MILLING_KWH_PER_TONNE * tariff.rate) / 1000; // rate is Kč/MWh
  return Math.round(energyCost + FIXED_COST_PER_TONNE_KC);
}

/**
 * Returns { tariff, costKc, equation } for transparent UI display.
 */
export function costBreakdown(now = new Date()) {
  const tariff = currentTariff(now);
  const costKc = costPerTonne(tariff);
  return {
    tariff,
    costKc,
    equation: `${MILLING_KWH_PER_TONNE} kWh/t × ${tariff.rate} CZK/MWh ÷ 1000 + ${FIXED_COST_PER_TONNE_KC} CZK`,
  };
}
